import { useRef, useEffect, useState } from 'react';
import { HTTP_METHOD, getDefaultOptions } from '../async/GetAsyncOptions';
import { IAppConfig } from '../interface/IAppConfig';
import { EMAIL_EVENT } from '../interface/IPayload';
import { useGlobalDispatch } from '../context/AppContext';
import track, { errorTypes } from 'c9-tracking';

export const useInsuranceStatus = (props: IAppConfig, isValidInsurance: boolean | null) => {
    const isLoggedOn = window.topContext.user.isLoggedOn;
    const [userCanProceed, setUserCanProceed] = useState<{ canProceed: boolean | undefined; message: string }>({
        canProceed: undefined,
        message: ''
    });
    const [error, setError] = useState<unknown>(false);
    const isLoading = useRef(false);
    const appDispatch = useGlobalDispatch();
    useEffect(() => {
        const fetchInsuranceStatus = async () => {
            isLoading.current = true;
            const options = getDefaultOptions(HTTP_METHOD.GET, props, 'wso2Secured');
            try {
                const response = await fetch(
                    `${props.apiGatewayBase}/v2/onlinesales-services/api/insurance/travel/status`,
                    options
                );
                if (response.ok) {
                    const data = await response.json();
                    if (data.message === 'Customer has an existing Travel Insurance in household') {
                        track.fault(`Customer can't proceed due to ${data.message}`, errorTypes.rule, 'Login');
                        appDispatch({ emailEvent: EMAIL_EVENT.HAS_EXISTING_TRAVEL });
                        appDispatch({ isLoading: false, hasError: { stepOne: true, stepTwo: false } });
                    }
                    setUserCanProceed(data);
                } else {
                    setError(true);
                    setUserCanProceed({ canProceed: true, message: '' });
                }
            } catch (error) {
                setError(error);
                setUserCanProceed({ canProceed: true, message: '' });
            } finally {
                isLoading.current = false;
            }
        };

        if (!isLoading.current && isLoggedOn && isValidInsurance === null) {
            fetchInsuranceStatus();
        }
    }, [props, isValidInsurance, isLoggedOn, appDispatch]);

    return { userCanProceed, isLoading: isLoading.current, error };
};
